import script from "./Page_1.vue?vue&type=script&setup=true&lang=js"
export * from "./Page_1.vue?vue&type=script&setup=true&lang=js"

import "./Page_1.vue?vue&type=style&index=0&id=0e31be09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e31be09"]])

export default __exports__